import Localization from '../../shared/localization/LocalizationManager'

enum LogisticActionTypes {
  SUBSCRIBE = 'SUBSCRIBE',
  UPDATE_STATUS = 'UPDATE_STATUS',
  DUPLICATE = 'DUPLICATE',
  DELETE = 'DELETE',
}

export const getLogisticActionTypeDisplayName = (type: LogisticActionTypes) => {
  switch (type) {
    case LogisticActionTypes.SUBSCRIBE:
      return Localization.translator.subscribe_verb
    case LogisticActionTypes.UPDATE_STATUS:
      return Localization.translator.updateStatus
    case LogisticActionTypes.DUPLICATE:
      return Localization.translator.duplicate_verb
    case LogisticActionTypes.DELETE:
      return Localization.translator.delete
    default:
      throw new Error(type + ' is unhandled')
  }
}

export default LogisticActionTypes
